import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import {
  TFilterSelected,
  TListingFetchReason,
  TREQUEST_UPDATE_MACHINE_SERVICE_TASKS,
  TRESPONSE_MACHINE_SERVICE_LIST,
} from '@monorepo/types';
import * as MachineServiceListActions from './machine-service.actions';
import * as MachineServiceListSelector from './machine-service.selectors';
import { TUserPaginationOption } from '@monorepo/ui';
import { LIST_ITEMS_PER_PAGE_LIST } from '../../constants/constants';
import { LOCAL_STORAGE_UTILS } from '@monorepo/utils';

@Injectable({
  providedIn: 'root',
})
export class MachineServiceListFacade {
  constructor(private store: Store<TMachineMaintenanceState>) {
    this.initializePagination();
  }

  initializePagination() {
    const storedPageSize = LOCAL_STORAGE_UTILS.retrieveData('machineServiceListPageSize');
    if (storedPageSize && LIST_ITEMS_PER_PAGE_LIST.includes(Number(storedPageSize))) {
      this.setPagination({
        pageNo: 1,
        pageSize: parseInt(storedPageSize),
      });
    } else {
      LOCAL_STORAGE_UTILS.storeData('machineServiceListPageSize', LIST_ITEMS_PER_PAGE_LIST[0].toString());
      this.setPagination({
        pageNo: 1,
        pageSize: LIST_ITEMS_PER_PAGE_LIST[0],
      });
    }
  }

  setPagination(pagination: TUserPaginationOption) {
    LOCAL_STORAGE_UTILS.storeData('machineServiceListPageSize', pagination.pageSize.toString());
    this.store.dispatch(new MachineServiceListActions.SetMachineServiceListPagination(pagination));
  }

  resetMachineServiceListInfo(fetchReason: TListingFetchReason) {
    const pageSize = Number(
      LOCAL_STORAGE_UTILS.retrieveData('machineServiceListPageSize') || LIST_ITEMS_PER_PAGE_LIST[0],
    );
    this.setPagination({ pageNo: 1, pageSize });
    this.fetchMachineServiceListInfo([], fetchReason);
  }

  fetchMachineServiceListInfo(selectedFilters: TFilterSelected[], fetchReason: TListingFetchReason) {
    this.store.dispatch(new MachineServiceListActions.GetMachineServiceList(selectedFilters, fetchReason));
  }

  updateMachineServiceTask(payload: TREQUEST_UPDATE_MACHINE_SERVICE_TASKS) {
    return this.store.dispatch(new MachineServiceListActions.UpdateMachineServiceTask(payload));
  }

  getMachineServiceListingInfo() {
    return this.store.pipe(select(MachineServiceListSelector.getMachineServiceListingInfo));
  }

  getPagination() {
    return this.store.pipe(select(MachineServiceListSelector.getPagination));
  }
}

export type TGetMachineServiceListingInfo = ReturnType<MachineServiceListFacade['getMachineServiceListingInfo']>;
export type TGetMachineServiceListPagination = ReturnType<MachineServiceListFacade['getPagination']>;
